import { render, staticRenderFns } from "./VuesticCheckbox.vue?vue&type=template&id=a5268f94"
import script from "./VuesticCheckbox.vue?vue&type=script&lang=js"
export * from "./VuesticCheckbox.vue?vue&type=script&lang=js"
import style0 from "./VuesticCheckbox.vue?vue&type=style&index=0&id=a5268f94&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pagsmile/front-end/pagsmile-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a5268f94')) {
      api.createRecord('a5268f94', component.options)
    } else {
      api.reload('a5268f94', component.options)
    }
    module.hot.accept("./VuesticCheckbox.vue?vue&type=template&id=a5268f94", function () {
      api.rerender('a5268f94', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vuestic-theme/vuestic-components/vuestic-checkbox/VuesticCheckbox.vue"
export default component.exports